import React, { Component } from "react";
import styled from "styled-components";
import { themeColors } from "js/react/sharedStyles";

export const Badge = styled.div`
  padding: 4px 12px;
  color: white;
  font-weight: 600;
  background: ${themeColors.ui_blue};
  border-radius: 4px;
  user-select: none;
`;

export class BetaBadge extends Component {
    render() {
        let { size } = this.props;

        return <Badge>BETA</Badge>;
    }
}
